import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "02255735-fe27-428a-ba10-88fae2193c8b"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter02255735Fe27428aBa1088fae2193c8b(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultFooter02255735Fe27428aBa1088fae2193c8b footer`}>
      {props["links"] || <Navigation className="Links3b11bf15D5284696A1f32ba02deec24b" parentTag={buildClassName("Links3b11bf15D5284696A1f32ba02deec24b", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo4f2d99eb2cdc4dc2894821b1384c1cbd" parentTag={buildClassName("Logo4f2d99eb2cdc4dc2894821b1384c1cbd", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightAd4c670fF6a7469e9142Affe028c9ab1" parentTag={buildClassName("CopyrightAd4c670fF6a7469e9142Affe028c9ab1", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowF3479c3d1454462fA4acCae10668f169" parentTag={buildClassName("GroupflowF3479c3d1454462fA4acCae10668f169", parentTag)} {...props} />}
    </div>
  );
}

// id: "c6d47dcd-dbcc-44d5-aafc-ebdffdfe64b5"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopC6d47dcdDbcc44d5AafcEbdffdfe64b5(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopC6d47dcdDbcc44d5AafcEbdffdfe64b5 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogoC8b96e29B97e468aBbedC5e59980f73e" parentTag={buildClassName("LinkedLogoC8b96e29B97e468aBbedC5e59980f73e", parentTag)} label={<Logo className="Label116b9d55F53d460e9c7cC49855dcf515" parentTag={buildClassName("Label116b9d55F53d460e9c7cC49855dcf515", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} className="linked-logo" url="/" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="NavigationE24427e44be5401191c8Aa394f16cf8b" parentTag={buildClassName("NavigationE24427e44be5401191c8Aa394f16cf8b", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "3a1dc6ac-b37e-469b-9f9d-bd97afd16510"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopC6d47dcdDbcc44d5AafcEbdffdfe64b5 parentTag="HeaderTop0dda94582d354d0e913f3bd201400a3b" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHeroD61b2a831d644738A4c4719bc23ed679 parentTag="Hero8efb5fb20bb143b48c57A4a7cedf9d81" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "2b5e4892-cda7-47e9-a688-2f74eca39265"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPage2b5e4892Cda747e9A6882f74eca39265(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPage2b5e4892Cda747e9A6882f74eca39265 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510 parentTag="Header271aacda5135422a80aa99c91bea0146" title="About Us" {...props} />}
      {props["main"] || <MainC56eefc670ea4c94994210b7b1c35c35 />}
      {props["footer"] || <DefaultFooter02255735Fe27428aBa1088fae2193c8b parentTag="Footer0d8cd590621f46339819C985f5ec184a" {...props} />}
    </div>
  );
}

// id: "0c86bd6f-6f0c-45f8-b8ba-822f0954652a"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPage0c86bd6f6f0c45f8B8ba822f0954652a(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPage0c86bd6f6f0c45f8B8ba822f0954652a`}>
      {props["header"] || <SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510 parentTag="HeaderE157ae2492ca47e095886618dcc123de" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter02255735Fe27428aBa1088fae2193c8b parentTag="FooterAd2b1e3d1ce9459dB9b42c64a26d579b" {...props} />}
    </div>
  );
}

// id: "5dce7bd7-f69d-4f2a-90a2-a49d4ea3900a"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage5dce7bd7F69d4f2a90a2A49d4ea3900a(props: any) {
  return (
    <SecondaryPageB9948ab8A1c04aa4A5dc05bb15bd4641 parentTag="JoinUsPage5dce7bd7F69d4f2a90a2A49d4ea3900a" header={<SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510 parentTag="Header8cfa86b51389450f98484a3bc8c03c27" title="Join Us" />} {...props} />
  );
}

// id: "1359e263-160a-4314-80fe-8be85f55c3fb"
// title: "Member Application Pages"
// type: :reference
// key: "application-pages"
// parent_id: nil
export function ApplicationPages1359e263160a431480fe8be85f55c3fb(props: any) {
  return (
    <SecondaryPageB9948ab8A1c04aa4A5dc05bb15bd4641 parentTag="ApplicationPages1359e263160a431480fe8be85f55c3fb" header={<SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510 parentTag="Header37733c0bD82b421d8f2b223637aa2914" title="Join Us" />} {...props} />
  );
}

// id: "b9948ab8-a1c0-4aa4-a5dc-05bb15bd4641"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPageB9948ab8A1c04aa4A5dc05bb15bd4641(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPageB9948ab8A1c04aa4A5dc05bb15bd4641`}>
      {props["header"] || <SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510 parentTag="Header745d341a8454408591b839ee9216426c" title="Secondary Page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter02255735Fe27428aBa1088fae2193c8b parentTag="Footer9c4bbd1c30d646949f0960936132267f" {...props} />}
    </div>
  );
}

// id: "d61b2a83-1d64-4738-a4c4-719bc23ed679"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHeroD61b2a831d644738A4c4719bc23ed679(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeroD61b2a831d644738A4c4719bc23ed679 hero`}>
      <h1 className="title">
        {props["title"] || Title5243a05aD90943dbB50e87a00a848ba2}
      </h1>
    </div>
  );
}

// id: "a5a63df2-2245-4e98-a2c7-78283457aa26"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePageA5a63df222454e98A2c778283457aa26(props: any) {
  const Header = AppStore.presets["Header"];
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageA5a63df222454e98A2c778283457aa26 gf-page-layout`}>
      {props["header-wrapper"] || <HeaderWrapper6cc29b464b604f8f91d6A950484b3bcf />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBackE7a62e78Ef6140d7A992174c4f4f43e1" parentTag={buildClassName("WelcomeBackE7a62e78Ef6140d7A992174c4f4f43e1", parentTag)} {...props} />}
      {props["main"] || <Main7af2142d84c44385A0e21f6f9ab63932 />}
      {props["quote"] || <PageQuote className="Quote1606e7fb831b4e6c83c0A68b5fe25a5b" parentTag={buildClassName("Quote1606e7fb831b4e6c83c0A68b5fe25a5b", parentTag)} contentSlug="home-page-quote" {...props} />}
      {props["footer"] || <DefaultFooter02255735Fe27428aBa1088fae2193c8b parentTag="Footer39b78c6a088b46daBa572a5bb74f1fb7" {...props} />}
    </div>
  );
}

// id: "f3479c3d-1454-462f-a4ac-cae10668f169"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "02255735-fe27-428a-ba10-88fae2193c8b"
export function GroupflowF3479c3d1454462fA4acCae10668f169(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowF3479c3d1454462fA4acCae10668f169" parentTag={buildClassName("GroupflowF3479c3d1454462fA4acCae10668f169", parentTag)} {...props} />
  );
}

// id: "59576f7c-1820-41d1-9bc9-c34ecd272bf9"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "c6d47dcd-dbcc-44d5-aafc-ebdffdfe64b5"
export function Logo59576f7c182041d19bc9C34ecd272bf9(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo59576f7c182041d19bc9C34ecd272bf9" parentTag={buildClassName("Logo59576f7c182041d19bc9C34ecd272bf9", parentTag)} logoType="DEFAULT" {...props} />
  );
}

// id: "0dda9458-2d35-4d0e-913f-3bd201400a3b"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "3a1dc6ac-b37e-469b-9f9d-bd97afd16510"
export function HeaderTop0dda94582d354d0e913f3bd201400a3b(props: any) {
  return (
    <DefaultHeaderTopC6d47dcdDbcc44d5AafcEbdffdfe64b5 parentTag="HeaderTop0dda94582d354d0e913f3bd201400a3b" {...props} />
  );
}

// id: "4f2d99eb-2cdc-4dc2-8948-21b1384c1cbd"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "02255735-fe27-428a-ba10-88fae2193c8b"
export function Logo4f2d99eb2cdc4dc2894821b1384c1cbd(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo4f2d99eb2cdc4dc2894821b1384c1cbd" parentTag={buildClassName("Logo4f2d99eb2cdc4dc2894821b1384c1cbd", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "ad2b1e3d-1ce9-459d-b9b4-2c64a26d579b"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "0c86bd6f-6f0c-45f8-b8ba-822f0954652a"
export function FooterAd2b1e3d1ce9459dB9b42c64a26d579b(props: any) {
  return (
    <DefaultFooter02255735Fe27428aBa1088fae2193c8b parentTag="FooterAd2b1e3d1ce9459dB9b42c64a26d579b" {...props} />
  );
}

// id: "c8b96e29-b97e-468a-bbed-c5e59980f73e"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "c6d47dcd-dbcc-44d5-aafc-ebdffdfe64b5"
export function LinkedLogoC8b96e29B97e468aBbedC5e59980f73e(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogoC8b96e29B97e468aBbedC5e59980f73e" parentTag={buildClassName("LinkedLogoC8b96e29B97e468aBbedC5e59980f73e", parentTag)} label={<Logo className="Label116b9d55F53d460e9c7cC49855dcf515" parentTag={buildClassName("Label116b9d55F53d460e9c7cC49855dcf515", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} className="linked-logo" url="/" {...props} />
  );
}

// id: "5243a05a-d909-43db-b50e-87a00a848ba2"
// title: ""
// type: :text
// key: "title"
// parent_id: "d61b2a83-1d64-4738-a4c4-719bc23ed679"
export const Title5243a05aD90943dbB50e87a00a848ba2 = "Default Title";

// id: "7af2142d-84c4-4385-a0e2-1f6f9ab63932"
// title: "Home Main"
// type: :html
// key: "main"
// parent_id: "a5a63df2-2245-4e98-a2c7-78283457aa26"
export function Main7af2142d84c44385A0e21f6f9ab63932(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main7af2142d84c44385A0e21f6f9ab63932`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards6caeb11dB09c4592Aaaf303822585858" parentTag={buildClassName("Cards6caeb11dB09c4592Aaaf303822585858", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "e7a62e78-ef61-40d7-a992-174c4f4f43e1"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "a5a63df2-2245-4e98-a2c7-78283457aa26"
export function WelcomeBackE7a62e78Ef6140d7A992174c4f4f43e1(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBackE7a62e78Ef6140d7A992174c4f4f43e1" parentTag={buildClassName("WelcomeBackE7a62e78Ef6140d7A992174c4f4f43e1", parentTag)} {...props} />
  );
}

// id: "c56eefc6-70ea-4c94-9942-10b7b1c35c35"
// title: ""
// type: :html
// key: "main"
// parent_id: "2b5e4892-cda7-47e9-a688-2f74eca39265"
export function MainC56eefc670ea4c94994210b7b1c35c35(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} MainC56eefc670ea4c94994210b7b1c35c35`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards5387175367f547f389e748b49e290ff3" parentTag={buildClassName("Cards5387175367f547f389e748b49e290ff3", parentTag)} postSlug="about-us-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "37733c0b-d82b-421d-8f2b-223637aa2914"
// title: ""
// type: :reference
// key: "header"
// parent_id: "1359e263-160a-4314-80fe-8be85f55c3fb"
export function Header37733c0bD82b421d8f2b223637aa2914(props: any) {
  return (
    <SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510 parentTag="Header37733c0bD82b421d8f2b223637aa2914" title="Join Us" {...props} />
  );
}

// id: "e24427e4-4be5-4011-91c8-aa394f16cf8b"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "c6d47dcd-dbcc-44d5-aafc-ebdffdfe64b5"
export function NavigationE24427e44be5401191c8Aa394f16cf8b(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationE24427e44be5401191c8Aa394f16cf8b" parentTag={buildClassName("NavigationE24427e44be5401191c8Aa394f16cf8b", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "8cfa86b5-1389-450f-9848-4a3bc8c03c27"
// title: ""
// type: :reference
// key: "header"
// parent_id: "5dce7bd7-f69d-4f2a-90a2-a49d4ea3900a"
export function Header8cfa86b51389450f98484a3bc8c03c27(props: any) {
  return (
    <SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510 parentTag="Header8cfa86b51389450f98484a3bc8c03c27" title="Join Us" {...props} />
  );
}

// id: "e157ae24-92ca-47e0-9588-6618dcc123de"
// title: ""
// type: :reference
// key: "header"
// parent_id: "0c86bd6f-6f0c-45f8-b8ba-822f0954652a"
export function HeaderE157ae2492ca47e095886618dcc123de(props: any) {
  return (
    <SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510 parentTag="HeaderE157ae2492ca47e095886618dcc123de" title="Public Events" {...props} />
  );
}

// id: "84b910e1-79d4-4e82-a12e-ee6e07e21374"
// title: ""
// type: :text
// key: "title"
// parent_id: "3a1dc6ac-b37e-469b-9f9d-bd97afd16510"
export const Title84b910e179d44e82A12eEe6e07e21374 = "Secondary Marketing Title 1";

// id: "3b11bf15-d528-4696-a1f3-2ba02deec24b"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "02255735-fe27-428a-ba10-88fae2193c8b"
export function Links3b11bf15D5284696A1f32ba02deec24b(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links3b11bf15D5284696A1f32ba02deec24b" parentTag={buildClassName("Links3b11bf15D5284696A1f32ba02deec24b", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "745d341a-8454-4085-91b8-39ee9216426c"
// title: ""
// type: :reference
// key: "header"
// parent_id: "b9948ab8-a1c0-4aa4-a5dc-05bb15bd4641"
export function Header745d341a8454408591b839ee9216426c(props: any) {
  return (
    <SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510 parentTag="Header745d341a8454408591b839ee9216426c" title="Secondary Page" {...props} />
  );
}

// id: "0d8cd590-621f-4633-9819-c985f5ec184a"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "2b5e4892-cda7-47e9-a688-2f74eca39265"
export function Footer0d8cd590621f46339819C985f5ec184a(props: any) {
  return (
    <DefaultFooter02255735Fe27428aBa1088fae2193c8b parentTag="Footer0d8cd590621f46339819C985f5ec184a" {...props} />
  );
}

// id: "8efb5fb2-0bb1-43b4-8c57-a4a7cedf9d81"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "3a1dc6ac-b37e-469b-9f9d-bd97afd16510"
export function Hero8efb5fb20bb143b48c57A4a7cedf9d81(props: any) {
  return (
    <SecondaryMarketingHeroD61b2a831d644738A4c4719bc23ed679 parentTag="Hero8efb5fb20bb143b48c57A4a7cedf9d81" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "271aacda-5135-422a-80aa-99c91bea0146"
// title: ""
// type: :reference
// key: "header"
// parent_id: "2b5e4892-cda7-47e9-a688-2f74eca39265"
export function Header271aacda5135422a80aa99c91bea0146(props: any) {
  return (
    <SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510 parentTag="Header271aacda5135422a80aa99c91bea0146" title="About Us" {...props} />
  );
}

// id: "9c4bbd1c-30d6-4694-9f09-60936132267f"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "b9948ab8-a1c0-4aa4-a5dc-05bb15bd4641"
export function Footer9c4bbd1c30d646949f0960936132267f(props: any) {
  return (
    <DefaultFooter02255735Fe27428aBa1088fae2193c8b parentTag="Footer9c4bbd1c30d646949f0960936132267f" {...props} />
  );
}

// id: "ad4c670f-f6a7-469e-9142-affe028c9ab1"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "02255735-fe27-428a-ba10-88fae2193c8b"
export function CopyrightAd4c670fF6a7469e9142Affe028c9ab1(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightAd4c670fF6a7469e9142Affe028c9ab1" parentTag={buildClassName("CopyrightAd4c670fF6a7469e9142Affe028c9ab1", parentTag)} {...props} />
  );
}

// id: "1606e7fb-831b-4e6c-83c0-a68b5fe25a5b"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "a5a63df2-2245-4e98-a2c7-78283457aa26"
export function Quote1606e7fb831b4e6c83c0A68b5fe25a5b(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="Quote1606e7fb831b4e6c83c0A68b5fe25a5b" parentTag={buildClassName("Quote1606e7fb831b4e6c83c0A68b5fe25a5b", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "39b78c6a-088b-46da-ba57-2a5bb74f1fb7"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "a5a63df2-2245-4e98-a2c7-78283457aa26"
export function Footer39b78c6a088b46daBa572a5bb74f1fb7(props: any) {
  return (
    <DefaultFooter02255735Fe27428aBa1088fae2193c8b parentTag="Footer39b78c6a088b46daBa572a5bb74f1fb7" {...props} />
  );
}

// id: "116b9d55-f53d-460e-9c7c-c49855dcf515"
// title: "Home Page Logo"
// type: :gf_preset
// key: "label"
// parent_id: "c8b96e29-b97e-468a-bbed-c5e59980f73e"
export function Label116b9d55F53d460e9c7cC49855dcf515(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Label116b9d55F53d460e9c7cC49855dcf515" parentTag={buildClassName("Label116b9d55F53d460e9c7cC49855dcf515", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />
  );
}

// id: "c93662e6-31c0-4f67-b7a3-1e6ce1ad7a84"
// title: ""
// type: :text
// key: "class"
// parent_id: "e24427e4-4be5-4011-91c8-aa394f16cf8b"
export const ClassC93662e631c04f67B7a31e6ce1ad7a84 = "navigation";

// id: "2df7e605-2c6e-4779-9478-f5f957ee76d2"
// title: ""
// type: :text
// key: "class"
// parent_id: "c8b96e29-b97e-468a-bbed-c5e59980f73e"
export const Class2df7e6052c6e47799478F5f957ee76d2 = "linked-logo";

// id: "1770ed92-3c5e-401e-af91-7f38a6c789c4"
// title: ""
// type: :html
// key: "hero-wrapper"
// parent_id: "6cc29b46-4b60-4f8f-91d6-a950484b3bcf"
export function HeroWrapper1770ed923c5e401eAf917f38a6c789c4(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeroWrapper1770ed923c5e401eAf917f38a6c789c4`}>
      {props["hero"] || <Hero className="Hero25888737253c4692A7a4A03960a7ec26" parentTag={buildClassName("Hero25888737253c4692A7a4A03960a7ec26", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "53871753-67f5-47f3-89e7-48b49e290ff3"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "c56eefc6-70ea-4c94-9942-10b7b1c35c35"
export function Cards5387175367f547f389e748b49e290ff3(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards5387175367f547f389e748b49e290ff3" parentTag={buildClassName("Cards5387175367f547f389e748b49e290ff3", parentTag)} postSlug="about-us-cards" {...props} />
  );
}

// id: "6281b5e2-375e-4c18-870e-2278efb21b78"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "1606e7fb-831b-4e6c-83c0-a68b5fe25a5b"
export const ContentSlug6281b5e2375e4c18870e2278efb21b78 = "home-page-quote";

// id: "8d74d73a-5e9b-4d6d-86f6-c21956012272"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "6cc29b46-4b60-4f8f-91d6-a950484b3bcf"
export function HeaderTop8d74d73a5e9b4d6d86f6C21956012272(props: any) {
  return (
    <DefaultHeaderTopC6d47dcdDbcc44d5AafcEbdffdfe64b5 parentTag="HeaderTop8d74d73a5e9b4d6d86f6C21956012272" {...props} />
  );
}

// id: "4fbc0fda-e04d-42a9-8ae6-7bdc5be66770"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "59576f7c-1820-41d1-9bc9-c34ecd272bf9"
export const LogoType4fbc0fdaE04d42a98ae67bdc5be66770 = "DEFAULT";

// id: "2be22d87-c306-4295-bcd8-a89b2301b48a"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "e24427e4-4be5-4011-91c8-aa394f16cf8b"
export const NavMenuSlug2be22d87C3064295Bcd8A89b2301b48a = "marketing-primary-nav";

// id: "d81fc77e-6192-47a9-be6b-dce4938bcb6e"
// title: ""
// type: :text
// key: "title"
// parent_id: "745d341a-8454-4085-91b8-39ee9216426c"
export const TitleD81fc77e619247a9Be6bDce4938bcb6e = "Secondary Page";

// id: "2019dcc0-048b-42a1-bdfb-8041ebbad17f"
// title: ""
// type: :text
// key: "title"
// parent_id: "e157ae24-92ca-47e0-9588-6618dcc123de"
export const Title2019dcc0048b42a1Bdfb8041ebbad17f = "Public Events";

// id: "68e1cafa-49e0-4c42-a847-1ac72fcd9563"
// title: ""
// type: :text
// key: "url"
// parent_id: "c8b96e29-b97e-468a-bbed-c5e59980f73e"
export const Url68e1cafa49e04c42A8471ac72fcd9563 = "/";

// id: "6caeb11d-b09c-4592-aaaf-303822585858"
// title: "Home Cards"
// type: :gf_preset
// key: "cards"
// parent_id: "7af2142d-84c4-4385-a0e2-1f6f9ab63932"
export function Cards6caeb11dB09c4592Aaaf303822585858(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards6caeb11dB09c4592Aaaf303822585858" parentTag={buildClassName("Cards6caeb11dB09c4592Aaaf303822585858", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />
  );
}

// id: "6078f3c3-fc9d-490b-bf36-e1be38dd0516"
// title: ""
// type: :text
// key: "title"
// parent_id: "8cfa86b5-1389-450f-9848-4a3bc8c03c27"
export const Title6078f3c3Fc9d490bBf36E1be38dd0516 = "Join Us";

// id: "76d3affa-7187-4cfe-9fa7-9c3a7b08e3ca"
// title: ""
// type: :text
// key: "title"
// parent_id: "37733c0b-d82b-421d-8f2b-223637aa2914"
export const Title76d3affa71874cfe9fa79c3a7b08e3ca = "Join Us";

// id: "4e054fa0-e5a9-4a9c-b567-836903e4efdf"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "3b11bf15-d528-4696-a1f3-2ba02deec24b"
export const NavMenuSlug4e054fa0E5a94a9cB567836903e4efdf = "footer-nav";

// id: "6945200f-60a7-4019-9c92-73fe6d900745"
// title: ""
// type: :text
// key: "title"
// parent_id: "271aacda-5135-422a-80aa-99c91bea0146"
export const Title6945200f60a740199c9273fe6d900745 = "About Us";

// id: "53b9243b-2b43-4556-8f5f-7404529e39a4"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "4f2d99eb-2cdc-4dc2-8948-21b1384c1cbd"
export const LogoType53b9243b2b4345568f5f7404529e39a4 = "FOOTER";

// id: "24316b32-10b8-4731-a6fa-8432d9cbaa2d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "4f2d99eb-2cdc-4dc2-8948-21b1384c1cbd"
export const ContentSlug24316b3210b84731A6fa8432d9cbaa2d = "footer-logo";

// id: "7dd4206e-878c-449f-bf2f-ebe05e93fc0f"
// title: ""
// type: :text
// key: "title"
// parent_id: "8efb5fb2-0bb1-43b4-8c57-a4a7cedf9d81"
export const Title7dd4206e878c449fBf2fEbe05e93fc0f = "Secondary Marketing Title 2";

// id: "9dc7cb7c-bfbf-4207-a859-61e5e9765e0c"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "6caeb11d-b09c-4592-aaaf-303822585858"
export const ButtonClass9dc7cb7cBfbf4207A85961e5e9765e0c = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "9299c4e8-ef91-4d5f-ab2e-9b75d806d5a8"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "6caeb11d-b09c-4592-aaaf-303822585858"
export const PostSlug9299c4e8Ef914d5fAb2e9b75d806d5a8 = "home-page-cards";

// id: "25888737-253c-4692-a7a4-a03960a7ec26"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "1770ed92-3c5e-401e-af91-7f38a6c789c4"
export function Hero25888737253c4692A7a4A03960a7ec26(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero25888737253c4692A7a4A03960a7ec26" parentTag={buildClassName("Hero25888737253c4692A7a4A03960a7ec26", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "3bc542c7-504b-40fa-bbae-d42106e5af24"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "116b9d55-f53d-460e-9c7c-c49855dcf515"
export const LogoType3bc542c7504b40faBbaeD42106e5af24 = "DEFAULT";

// id: "ba124934-ddc3-4f6b-be0d-4efdd296cd3f"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "53871753-67f5-47f3-89e7-48b49e290ff3"
export const PostSlugBa124934Ddc34f6bBe0d4efdd296cd3f = "about-us-cards";

// id: "60fb67f2-d61d-4b58-b0a2-1217b5193d9a"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "116b9d55-f53d-460e-9c7c-c49855dcf515"
export const ContentSlug60fb67f2D61d4b58B0a21217b5193d9a = "header-logo";

// id: "f4bac003-4262-4493-9d5c-393ec96d3146"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "25888737-253c-4692-a7a4-a03960a7ec26"
export const PostSlugF4bac003426244939d5c393ec96d3146 = "home-hero";

// id: "6cc29b46-4b60-4f8f-91d6-a950484b3bcf"
// title: "Home Header Wrapper"
// type: :html
// key: "header-wrapper"
// parent_id: "a5a63df2-2245-4e98-a2c7-78283457aa26"
export function HeaderWrapper6cc29b464b604f8f91d6A950484b3bcf(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeaderWrapper6cc29b464b604f8f91d6A950484b3bcf`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopC6d47dcdDbcc44d5AafcEbdffdfe64b5 parentTag="HeaderTop8d74d73a5e9b4d6d86f6C21956012272" {...props} />}
      </div>
      {props["hero-wrapper"] || <HeroWrapper1770ed923c5e401eAf917f38a6c789c4 />}
    </div>
  );
}

const Components = {
  DefaultFooter02255735Fe27428aBa1088fae2193c8b,
  DefaultHeaderTopC6d47dcdDbcc44d5AafcEbdffdfe64b5,
  SecondaryMarketingHeader3a1dc6acB37e469b9f9dBd97afd16510,
  AboutUsPage2b5e4892Cda747e9A6882f74eca39265,
  PublicEventsPage0c86bd6f6f0c45f8B8ba822f0954652a,
  JoinUsPage5dce7bd7F69d4f2a90a2A49d4ea3900a,
  ApplicationPages1359e263160a431480fe8be85f55c3fb,
  SecondaryPageB9948ab8A1c04aa4A5dc05bb15bd4641,
  SecondaryMarketingHeroD61b2a831d644738A4c4719bc23ed679,
  HomePageA5a63df222454e98A2c778283457aa26,
  GroupflowF3479c3d1454462fA4acCae10668f169,
  Logo59576f7c182041d19bc9C34ecd272bf9,
  HeaderTop0dda94582d354d0e913f3bd201400a3b,
  Logo4f2d99eb2cdc4dc2894821b1384c1cbd,
  FooterAd2b1e3d1ce9459dB9b42c64a26d579b,
  LinkedLogoC8b96e29B97e468aBbedC5e59980f73e,
  Title5243a05aD90943dbB50e87a00a848ba2,
  Main7af2142d84c44385A0e21f6f9ab63932,
  WelcomeBackE7a62e78Ef6140d7A992174c4f4f43e1,
  MainC56eefc670ea4c94994210b7b1c35c35,
  Header37733c0bD82b421d8f2b223637aa2914,
  NavigationE24427e44be5401191c8Aa394f16cf8b,
  Header8cfa86b51389450f98484a3bc8c03c27,
  HeaderE157ae2492ca47e095886618dcc123de,
  Title84b910e179d44e82A12eEe6e07e21374,
  Links3b11bf15D5284696A1f32ba02deec24b,
  Header745d341a8454408591b839ee9216426c,
  Footer0d8cd590621f46339819C985f5ec184a,
  Hero8efb5fb20bb143b48c57A4a7cedf9d81,
  Header271aacda5135422a80aa99c91bea0146,
  Footer9c4bbd1c30d646949f0960936132267f,
  CopyrightAd4c670fF6a7469e9142Affe028c9ab1,
  Quote1606e7fb831b4e6c83c0A68b5fe25a5b,
  Footer39b78c6a088b46daBa572a5bb74f1fb7,
  Label116b9d55F53d460e9c7cC49855dcf515,
  ClassC93662e631c04f67B7a31e6ce1ad7a84,
  Class2df7e6052c6e47799478F5f957ee76d2,
  HeroWrapper1770ed923c5e401eAf917f38a6c789c4,
  Cards5387175367f547f389e748b49e290ff3,
  ContentSlug6281b5e2375e4c18870e2278efb21b78,
  HeaderTop8d74d73a5e9b4d6d86f6C21956012272,
  LogoType4fbc0fdaE04d42a98ae67bdc5be66770,
  NavMenuSlug2be22d87C3064295Bcd8A89b2301b48a,
  TitleD81fc77e619247a9Be6bDce4938bcb6e,
  Title2019dcc0048b42a1Bdfb8041ebbad17f,
  Url68e1cafa49e04c42A8471ac72fcd9563,
  Cards6caeb11dB09c4592Aaaf303822585858,
  Title6078f3c3Fc9d490bBf36E1be38dd0516,
  Title76d3affa71874cfe9fa79c3a7b08e3ca,
  NavMenuSlug4e054fa0E5a94a9cB567836903e4efdf,
  Title6945200f60a740199c9273fe6d900745,
  LogoType53b9243b2b4345568f5f7404529e39a4,
  ContentSlug24316b3210b84731A6fa8432d9cbaa2d,
  Title7dd4206e878c449fBf2fEbe05e93fc0f,
  ButtonClass9dc7cb7cBfbf4207A85961e5e9765e0c,
  PostSlug9299c4e8Ef914d5fAb2e9b75d806d5a8,
  Hero25888737253c4692A7a4A03960a7ec26,
  LogoType3bc542c7504b40faBbaeD42106e5af24,
  PostSlugBa124934Ddc34f6bBe0d4efdd296cd3f,
  ContentSlug60fb67f2D61d4b58B0a21217b5193d9a,
  PostSlugF4bac003426244939d5c393ec96d3146,
  HeaderWrapper6cc29b464b604f8f91d6A950484b3bcf
}

export default Components;